import { useContext, useMemo, useState } from 'react';
import { CanvasFormTabsContext } from '../providers/canvas-form-tabs.provider';
import { getItemFromSchema, isDefined, setValue } from '../utils';
import { getAppliedSchemaIndex } from '../utils/get-applied-schema-index';
import { getOneOfSchemaList } from '../utils/get-oneof-schema-list';
import { SchemaContext } from '../providers/SchemaProvider';
import { useFieldValue } from './field-value';
export const useOneOfField = (propName) => {
    const { selectedTab } = useContext(CanvasFormTabsContext);
    const { schema, definitions } = useContext(SchemaContext);
    const { value, onChange } = useFieldValue(propName);
    const oneOfSchemas = useMemo(() => { var _a; return getOneOfSchemaList((_a = schema.oneOf) !== null && _a !== void 0 ? _a : [], definitions); }, [definitions, schema.oneOf]);
    const appliedSchemaIndex = getAppliedSchemaIndex(value, oneOfSchemas, definitions);
    const presetSchema = appliedSchemaIndex === -1 ? undefined : oneOfSchemas[appliedSchemaIndex];
    const [selectedOneOfSchema, setSelectedOneOfSchema] = useState(presetSchema);
    const onSchemaChange = (schema) => {
        if ((schema === null || schema === void 0 ? void 0 : schema.name) === (selectedOneOfSchema === null || selectedOneOfSchema === void 0 ? void 0 : selectedOneOfSchema.name)) {
            return;
        }
        if (!isDefined(schema === null || schema === void 0 ? void 0 : schema.schema)) {
            if (isDefined(value) && typeof value === 'object') {
                (selectedOneOfSchema === null || selectedOneOfSchema === void 0 ? void 0 : selectedOneOfSchema.schema.properties) &&
                    Object.keys(selectedOneOfSchema.schema.properties).forEach((prop) => delete value[prop]);
                onChange(value);
            }
            setSelectedOneOfSchema(schema);
            return;
        }
        let newValue = getItemFromSchema(schema === null || schema === void 0 ? void 0 : schema.schema, definitions);
        if (typeof newValue === 'object') {
            if (isDefined(value) && typeof value === 'object') {
                newValue = Object.assign({}, value);
                (selectedOneOfSchema === null || selectedOneOfSchema === void 0 ? void 0 : selectedOneOfSchema.schema.properties) &&
                    Object.keys(selectedOneOfSchema.schema.properties).forEach((prop) => delete newValue[prop]);
            }
            schema.schema.properties && Object.keys(schema.schema.properties).forEach((prop) => setValue(newValue, prop, {}));
            onChange(newValue);
        }
        setSelectedOneOfSchema(schema);
    };
    let shouldRender = true;
    if (selectedTab === 'Modified') {
        const selectedOneOfSchemaProperty = selectedOneOfSchema === null || selectedOneOfSchema === void 0 ? void 0 : selectedOneOfSchema.schema.properties;
        if (!selectedOneOfSchemaProperty || !isDefined(value)) {
            shouldRender = false;
        }
    }
    return {
        selectedOneOfSchema,
        oneOfSchemas,
        onSchemaChange,
        shouldRender,
    };
};
//# sourceMappingURL=one-of-field.js.map